! function (e) {
	if ("object" == typeof exports && "undefined" != typeof module) module.exports = e();
	else if ("function" == typeof define && define.amd) define([], e);
	else {
		var t;
		t = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this, t.Sidenav = e()
	}
}(function () {
	return function e(t, n, i) {
		function r(c, o) {
			if (!n[c]) {
				if (!t[c]) {
					var a = "function" == typeof require && require;
					if (!o && a) return a(c, !0);
					if (s) return s(c, !0);
					var d = new Error("Cannot find module '" + c + "'");
					throw d.code = "MODULE_NOT_FOUND", d
				}
				var u = n[c] = {
					exports: {}
				};
				t[c][0].call(u.exports, function (e) {
					var n = t[c][1][e];
					return r(n ? n : e)
				}, u, u.exports, e, t, n, i)
			}
			return n[c].exports
		}
		for (var s = "function" == typeof require && require, c = 0; c < i.length; c++) r(i[c]);
		return r
	}({
		1: [function (e, t, n) {
			"use strict";

			function i(e) {
				e = e || {}, this.extraClosePixels = e.extraClosePixels || 5, this.width = e.width || 240, this.sidenavOpacity = e.sidenavOpacity || .5, this.isBusy = !1, this.isOpened = !1, this.currentOpacity = 0, this.currentWidth = 0, this.sidenav = e.sidenav, this.backdrop = e.backdrop, this.content = e.content, this.content.classList.add("page"), this.sidenav.classList.add("sidebar"), this.sidenav.style.transform = "translate3d(" + (-1 * this.width - this.extraClosePixels) + "px, 0, 0)", this.backdrop.classList.add("sidebar-loader"), this.initEvents()
			}

			function r(e, t, n, i) {
				return e /= i, -n * e * (e - 2) + t
			}
			t.exports = i;
			var s = window.document,
				c = s.documentElement;
			i.prototype.open = function () {
				var e = this;
				if (e.isBusy) return false;
				e.isBusy = !0, c.classList.add("sidebar-open");
				var t = this.showHideSidebarBackdrop(!0);
				return t.then(function () {
					e.isBusy = !1, e.isOpened = !0
				})
			}, i.prototype.close = function () {
				var e = this;
				if (e.isBusy) return Promise.reject();
				e.isBusy = !0;
				var t = this.showHideSidebarBackdrop(!1);
				return t.then(function () {
					e.isBusy = !1, e.isOpened = !1, c.classList.remove("sidebar-open")
				})
			}, i.prototype.expandTo = function (e) {
				var t = this;
				e = Math.min(e, t.width);
				var n = t.sidenavOpacity * e / t.width;
				c.classList.add("sidebar-open"), t.sidenav.style.transform = "translate3d(" + (-t.width + e) + "px, 0, 0)", t.backdrop.style.opacity = n, t.currentOpacity = n, t.currentWidth = e
			}, i.prototype.showHideSidebarBackdrop = function (e) {
				var t = this,
					n = new Promise(function (n) {
						function i(o) {
							var a = 0;
							null === c ? c = o : a = Math.min(o - c, s);
							var d = null,
								u = null;
							e ? (d = r(a, t.currentOpacity, t.sidenavOpacity - t.currentOpacity, s), u = r(a, t.currentWidth, t.width - t.currentWidth, s)) : (d = t.currentOpacity - r(a, 0, t.currentOpacity, s), u = t.currentWidth - r(a, 0, t.currentWidth + t.extraClosePixels, s)), t.sidenav.style.transform = "translate3d(" + (-1 * t.width + u) + "px, 0, 0)", t.backdrop.style.opacity = d, s > a ? requestAnimationFrame(i) : (e ? (t.currentOpacity = t.sidenavOpacity, t.currentWidth = t.width) : (t.currentOpacity = 0, t.currentWidth = 0), n())
						}
						var s = 300,
							c = null;
						requestAnimationFrame(i)
					});
				return n
			}, i.prototype.initEvents = function () {
				function e(e) {
					r.isBusy || null === c && 1 === e.touches.length && (!r.isOpened && e.touches[0].clientX > 10 || (c = e.touches[0].identifier, o = e.touches[0].clientX, a = e.touches[0].clientY, d = r.currentWidth, u = !1, h = !1, l = -999, f = -999, s.addEventListener("touchmove", t), s.addEventListener("touchcancel", n), s.addEventListener("touchend", n)))
				}

				function t(e) {
					for (var t = 0; t < e.changedTouches.length; t++)
						if (c === e.changedTouches[t].identifier) {
							if (Math.abs(e.changedTouches[t].clientX - l) < 1 && Math.abs(e.changedTouches[t].clientY - f) < 1) return;
							if (l = e.changedTouches[t].clientX, f = e.changedTouches[t].clientY, r.isOpened) {
								if (!h && Math.abs(o - e.changedTouches[t].clientX) < Math.abs(a - e.changedTouches[t].clientY)) return void i(null);
								if (h = !0, !u && e.changedTouches[t].clientX > r.currentWidth) return
							}
							return u = !0, void r.expandTo(d + (e.changedTouches[t].clientX - Math.min(o, r.width)))
						}
				}

				function n(e) {
					for (var t = 0; t < e.changedTouches.length; t++) c === e.changedTouches[t].identifier && i(u ? r.currentWidth > r.width / 2 : null)
				}

				function i(i) {
					i === !0 ? r.open() : i === !1 && r.close(), s.removeEventListener("touchmove", t), s.removeEventListener("touchcancel", n), s.removeEventListener("touchend", e), c = null
				}
				var r = this,
					c = null,
					o = null,
					a = null,
					d = null,
					u = !1,
					h = !1,
					l = null,
					f = null;
				r.backdrop.addEventListener("click", function () {
					r.close()
				}), s.addEventListener("touchstart", e)
			}
		}, {}]
	}, {}, [1])(1)
});